import React from "react"
import Layout from "./Layout"
import { Box } from "@singita/components"
import { hideByTag } from "gatsby-singita-theme/src/common/utils"

const LodgeIntro = ({ lodge }) => {
  const patternProps = {
    color: lodge.color,
    path: lodge.pattern?.pattern,
  }
  return lodge.intro ? (
    <Box data-testid="lodge-intro" pt={[10, 20]}>
      <Layout
        layout={hideByTag(lodge.intro, "SPVC")}
        patternProps={patternProps}
      />
    </Box>
  ) : null
}

export default LodgeIntro
